// Shipments rated at once; each one is a full LTL job on the TMS.
export const BATCH_LTL_RATE_CONCURRENCY = 4;

export const BATCH_LTL_MIN_SHIPMENTS = 2;

// Saved batch work: bump the version when the saved shape changes so old entries are ignored.
export const BATCH_LTL_STORAGE_SCHEMA_VERSION = 2;

// How long a removed shipment can be brought back before its quote request is rejected.
export const BATCH_LTL_REMOVE_UNDO_MS = 6000;

export const BATCH_LTL_STORAGE_TTL_MS = 24 * 60 * 60 * 1000;

// localStorage is ~5 MB per origin and shared with Builder drafts.
export const BATCH_LTL_STORAGE_MAX_BYTES = 512 * 1024;

export const BATCH_LTL_SAVE_DEBOUNCE_MS = 300;

export const BATCH_LTL_RATE_FRACTION_DIGITS = 2;

export const BATCH_LTL_EMPTY_QUOTES_MESSAGE = 'No carriers returned rates.';

export const BATCH_LTL_SHIPPER_ERROR_TEXT =
  'We are still working on a rate for this shipment and will follow up.';

// Copy of the generic default in drumkit (email_template.go, QuickQuoteBatchLTLReply); used
// only when GET /email-templates returns no batch LTL template.
export const FALLBACK_BATCH_LTL_TEMPLATE = `<p>Hi,</p>
<p>Here are rates for your shipments:</p>
{{#shipments}}<p><strong>{{label}}</strong><br>{{originLabel}} to {{destinationLabel}}<br>{{freightSummary}}{{#hasAccessorials}}<br>{{accessorialsText}}{{/hasAccessorials}}</p>
{{#hasRates}}<table style="border-collapse: collapse; width: 100%; table-layout: fixed;"><colgroup><col style="width: 55%;"><col style="width: 20%;"><col style="width: 25%;"></colgroup><thead><tr><th style="text-align: left; padding: 4px 16px 4px 0;">Carrier</th><th style="text-align: left; padding: 4px 16px 4px 0;">Transit</th><th style="text-align: left; padding: 4px 0;">Rate</th></tr></thead><tbody>{{#rates}}<tr><td style="padding: 4px 16px 4px 0;">{{carrierName}}</td><td style="padding: 4px 16px 4px 0; white-space: nowrap;">{{transitDaysText}}</td><td style="padding: 4px 0; white-space: nowrap;">{{rate}}</td></tr>{{/rates}}</tbody></table>{{/hasRates}}
{{#hasQuoteNumber}}<p><strong>{{quoteNumberLabel}}:</strong> {{quoteNumber}}</p>{{/hasQuoteNumber}}{{#hasMissingInfo}}<p>{{missingInfoQuestion}}</p>{{/hasMissingInfo}}{{#hasError}}<p>{{errorText}}</p>{{/hasError}}<br>{{/shipments}}
<p>Please let me know if you have any questions or would like to book any of these.</p>
<p>Best regards</p>`;
